export default {
    pricingValidation: {
        // Dual Pricing
        dual_pricing: {
            dual_pricing_rate: {
                default: 4.0,
                minimum: 0.0,
                type: "v/mc/d",
            },
            dual_pricing_monthly_fee: {
                default: 49.0,
                minimum: 0,
                type: "v/mc/d",
            },
            dual_pricing_pin_debit_network_fee: {
                default: "yes",
                type: "debit",
            },
            dual_pricing_pin_debit_rate: {
                default: 0.0,
                minimum: 0.0,
                type: "debit",
            },
            dual_pricing_pin_debit_per_transaction: {
                default: 0.0,
                minimum: 0.0,
                type: "debit",
            },
            //  defaults
            chargeback_fee: {
                default: 15.0,
                minimum: 0.0,
                type: "default",
            },
            representment_fee: {
                default: 45.0,
                minimum: 0.0,
                type: "default",
            },
        },

        // surcharge
        surcharge: {
            surcharge_rate: {
                default: 3.0,
                minimum: 0.0,
                type: "v/mc/d",
            },
            surcharge_per_transaction: {
                default: 0.15,
                minimum: 0.0,
                type: "v/mc/d",
            },
            surcharge_monthly_fee: {
                default: 49.0,
                minimum: 0,
                type: "v/mc/d",
            },
            surcharge_pin_debit_rate: {
                default: 0.0,
                minimum: 0.0,
                type: "debit",
            },
            surcharge_pin_debit_per_transaction: {
                default: 0.0,
                minimum: 0.0,
                type: "debit",
            },
            surcharge_signature_debit_rate: {
                default: 3.0,
                minimum: 0.0,
                type: "debit",
            },
            surcharge_signature_debit_per_transaction: {
                default: 0.15,
                minimum: 0.0,
                type: "debit",
            },
            surcharge_pin_debit_network_fee: {
                default: "yes",
                type: "debit",
            },
            //  defaults
            chargeback_fee: {
                default: 15.0,
                minimum: 0.0,
                type: "default",
            },
            representment_fee: {
                default: 45.0,
                minimum: 0.0,
                type: "default",
            },
            surcharge_qual_debit_rate: {
                default: 1.5,
                minimum: 0.0,
                type: "debit",
            },
            surcharge_qual_debit_per_transaction: {
                default: 0.15,
                minimum: 0.0,
                type: "debit",
            },
            surcharge_mid_qual_debit_rate: {
                default: 1.99,
                minimum: 0.0,
                type: "debit",
            },
            surcharge_mid_qual_debit_per_transaction: {
                default: 0.15,
                minimum: 0.0,
                type: "debit",
            },
            surcharge_non_qual_debit_rate: {
                default: 2.49,
                minimum: 0.0,
                type: "debit",
            },
            surcharge_non_qual_debit_per_transaction: {
                default: 0.15,
                minimum: 0.0,
                type: "debit",
            },
        },

        // Flat Rate
        flat_rate: {
            flat_rate: {
                default: 3.0,
                minimum: 0.0,
                type: "v/mc/d",
            },
            flat_rate_transaction: {
                default: 0.15,
                minimum: 0,
                type: "v/mc/d",
            },
            flat_rate_amex: {
                default: 3.0,
                minimum: 0,
                type: "amex",
                min_fields: ["flat_rate", "flat_rate_pin_debit_rate"],
            },
            flat_rate_amex_transaction: {
                default: 0.15,
                minimum: 0.0,
                type: "amex",
                min_fields: [
                    "flat_rate_transaction",
                    "flat_rate_pin_debit_per_transaction",
                ],
            },
            flat_rate_pin_debit_rate: {
                default: 2.0,
                minimum: 0.0,
                type: "debit",
            },
            flat_rate_pin_debit_per_transaction: {
                default: 0.15,
                minimum: 0,
                type: "debit",
            },
            flat_rate_pin_debit_network_fee: {
                default: "yes",
                type: "debit",
            },
            //  defaults
            chargeback_fee: {
                default: 15.0,
                minimum: 0.0,
                type: "default",
            },
            representment_fee: {
                default: 45.0,
                minimum: 0.0,
                type: "default",
            },
        },

        // Tiered
        tiered: {
            tiered_qual_rate: {
                default: 1.75,
                minimum: 0.0,
                type: "v/mc/d",
            },
            tiered_qual_transaction: {
                default: 0.15,
                minimum: 0.0,
                type: "v/mc/d",
            },
            tiered_qual_debit_rate: {
                default: 1.5,
                minimum: 0.0,
                type: "debit",
            },
            tiered_qual_debit_per_transaction: {
                default: 0.15,
                minimum: 0.0,
                type: "debit",
            },

            tiered_mid_qual_rate: {
                default: 2.29,
                minimum: 0.0,
                type: "v/mc/d",
            },
            tiered_mid_qual_transaction: {
                default: 0.15,
                minimum: 0.0,
                type: "v/mc/d",
            },
            tiered_mid_qual_debit_rate: {
                default: 1.99,
                minimum: 0.0,
                type: "debit",
            },
            tiered_mid_qual_debit_per_transaction: {
                default: 0.15,
                minimum: 0.0,
                type: "debit",
            },

            tiered_non_qual_rate: {
                default: 2.99,
                minimum: 0.0,
                type: "v/mc/d",
            },
            tiered_non_qual_transaction: {
                default: 0.15,
                minimum: 0.0,
                type: "v/mc/d",
            },
            tiered_non_qual_debit_rate: {
                default: 2.49,
                minimum: 0.0,
                type: "debit",
            },
            tiered_non_qual_debit_per_transaction: {
                default: 0.15,
                minimum: 0.0,
                type: "debit",
            },

            amex_tier_one_rate: {
                default: 3.5,
                minimum: 0.0,
                type: "amex",
                min_fields: ["tiered_qual_rate", "tiered_qual_debit_rate"],
            },
            amex_tier_one_fee: {
                default: 0.2,
                minimum: 0.0,
                type: "amex",
                min_fields: [
                    "tiered_qual_transaction",
                    "tiered_qual_debit_per_transaction",
                ],
            },
            amex_tier_two_rate: {
                default: 3.5,
                minimum: 0.0,
                type: "amex",
                min_fields: [
                    "tiered_mid_qual_rate",
                    "tiered_mid_qual_debit_rate",
                ],
            },
            amex_tier_two_fee: {
                default: 0.2,
                minimum: 0.0,
                type: "amex",
                min_fields: [
                    "tiered_mid_qual_transaction",
                    "tiered_mid_qual_debit_per_transaction",
                ],
            },
            amex_tier_three_rate: {
                default: 3.5,
                minimum: 0.0,
                type: "amex",
                min_fields: [
                    "tiered_non_qual_rate",
                    "tiered_non_qual_debit_rate",
                ],
            },
            amex_tier_three_fee: {
                default: 0.2,
                minimum: 0.0,
                type: "amex",
                min_fields: [
                    "tiered_non_qual_transaction",
                    "tiered_non_qual_debit_per_transaction",
                ],
            },
            amex_tier_four_rate: {
                default: 3.5,
                minimum: 0.0,
                type: "amex",
                min_fields: ["tiered_qual_rate", "tiered_qual_debit_rate"],
            },
            amex_tier_four_fee: {
                default: 0.2,
                minimum: 0.0,
                type: "amex",
                min_fields: [
                    "tiered_qual_transaction",
                    "tiered_qual_debit_per_transaction",
                ],
            },

            tiered_amex_flat_rate: {
                default: 3.5,
                minimum: 0.0,
                type: "amex",
                min_fields: ["tiered_qual_rate", "tiered_qual_debit_rate"],
            },
            tiered_amex_flat_transaction: {
                default: 0.2,
                minimum: 0.0,
                type: "amex",
                min_fields: [
                    "tiered_qual_transaction",
                    "tiered_qual_debit_per_transaction",
                ],
            },

            tiered_amex_ic_plus_rate: {
                default: 3.5,
                minimum: 0.0,
                type: "amex",
                min_fields: ["tiered_qual_rate", "tiered_qual_debit_rate"],
            },
            tiered_amex_ic_plus_transaction: {
                default: 0.2,
                minimum: 0.0,
                type: "amex",
                min_fields: [
                    "tiered_qual_transaction",
                    "tiered_qual_debit_per_transaction",
                ],
            },

            tiered_pin_debit_network_fee: {
                default: "yes",
                type: "debit",
            },
            tiered_pin_debit_rate: {
                default: 0.0,
                minimum: 0.0,
                type: "debit",
            },
            tiered_pin_debit_per_transaction: {
                default: 0.0,
                minimum: 0.0,
                type: "debit",
            },

            //  defaults
            chargeback_fee: {
                default: 15.0,
                minimum: 0.0,
                type: "debit",
            },
            representment_fee: {
                default: 45.0,
                minimum: 0.0,
                type: "debit",
            },
        },

        // IC Plus
        ic_plus: {
            ic_plus_rate: {
                default: 0.15,
                minimum: 0.0,
                type: "v/mc/d",
            },
            ic_plus_transaction_fee: {
                default: 0.15,
                minimum: 0,
                type: "v/mc/d",
            },
            ic_plus_amex_rate: {
                default: 0.15,
                minimum: 0.0,
                type: "amex",
                min_fields: ["ic_plus_rate", "ic_plus_pin_debit_rate"],
            },
            ic_plus_amex_transaction_fee: {
                default: 0.15,
                minimum: 0,
                type: "amex",
                min_fields: [
                    "ic_plus_transaction_fee",
                    "ic_plus_pin_debit_per_transaction",
                ],
            },
            ic_plus_pin_debit_rate: {
                default: 0.0,
                minimum: 0.0,
                type: "debit",
            },
            ic_plus_pin_debit_per_transaction: {
                default: 0.0,
                minimum: 0.0,
                type: "debit",
            },
            ic_plus_pin_debit_network_fee: {
                default: "yes",
                type: "debit",
            },

            //  defaults
            chargeback_fee: {
                default: 15.0,
                minimum: 0.0,
                type: "debit",
            },
            representment_fee: {
                default: 45.0,
                minimum: 0.0,
                type: "debit",
            },
        },

        // default fees
        default_fee: {
            setup_fee: {
                default: 125.0,
                minimum: 0,
                type: "debit",
            },
            monthly_access_fee: {
                default: 15.0,
                minimum: 0,
                type: "debit",
            },
            data_breach: {
                default: 15.0,
                minimum: 0,
                type: "debit",
            },
            monthly_minimum: {
                default: 25.0,
                minimum: 0,
                type: "debit",
            },
            semi_annual_tech_fee: {
                default: 75.0,
                minimum: 0,
                type: "debit",
            },
            voice_aru: {
                default: 0.6,
                minimum: 0,
                type: "debit",
            },
            batch_fee: {
                default: 0.3,
                minimum: 0,
                type: "debit",
            },
            ebt_transactions: {
                default: 0.75,
                minimum: 0,
                type: "debit",
            },
            avs_fee: {
                default: 0.1,
                minimum: 0,
                type: "debit",
            },
            auth_transaction: {
                default: 0.25,
                minimum: 0,
                type: "debit",
            },
            monthly_cellular: {
                default: 25.0,
                minimum: 0,
                type: "debit",
            },
            cellular_transaction: {
                default: 0.1,
                minimum: 0,
                type: "debit",
            },
            etf_fee: {
                default: 595.0,
                minimum: 0,
                type: "debit",
            },
            chargeback_fee: {
                default: 45.0,
                minimum: 0.0,
                type: "debit",
            },
            representment_fee: {
                default: 45.0,
                minimum: 0.0,
                type: "debit",
            },
            pre_dispute_fee: {
                default: 45.0,
                minimum: 0,
                type: "debit",
            },
            returned_ach_item: {
                default: 25.0,
                minimum: 0,
                type: "debit",
            },
        },
        paychex_default_fee: {
            setup_fee: {
                default: 125.0,
                minimum: 0,
                type: "debit",
            },
            monthly_access_fee: {
                default: 15.0,
                minimum: 0,
                type: "debit",
            },
            data_breach: {
                default: 15.0,
                minimum: 0,
                type: "debit",
            },
            monthly_minimum: {
                default: 25.0,
                minimum: 0,
                type: "debit",
            },
            semi_annual_tech_fee: {
                default: 75.0,
                minimum: 0,
                type: "debit",
            },
            voice_aru: {
                default: 0.6,
                minimum: 0,
                type: "debit",
            },
            batch_fee: {
                default: 0.3,
                minimum: 0,
                type: "debit",
            },
            ebt_transactions: {
                default: 0.75,
                minimum: 0,
                type: "debit",
            },
            avs_fee: {
                default: 0.1,
                minimum: 0,
                type: "debit",
            },
            auth_transaction: {
                default: 0.25,
                minimum: 0,
                type: "debit",
            },
            monthly_cellular: {
                default: 25.0,
                minimum: 0,
                type: "debit",
            },
            cellular_transaction: {
                default: 0.1,
                minimum: 0,
                type: "debit",
            },
            etf_fee: {
                default: 595.0,
                minimum: 0,
                type: "debit",
            },
            chargeback_fee: {
                default: 45.0,
                minimum: 0.0,
                type: "debit",
            },
            representment_fee: {
                default: 45.0,
                minimum: 0.0,
                type: "debit",
            },
            pre_dispute_fee: {
                default: 45.0,
                minimum: 0,
                type: "debit",
            },
            returned_ach_item: {
                default: 25.0,
                minimum: 0,
                type: "debit",
            },
        },
    },
};
